import { labelToDifficulty } from '@/app/lib/schemas/mappers/enums-to-client-mappers';

import { Checkbox, Flex, Text } from '@radix-ui/themes';

interface Props {
  onCheckedChange: (label: string, checked: boolean) => void;
  checkboxStates: {
    [k: string]: boolean;
  };
}

export default function FilterDifficulty({
  onCheckedChange,
  checkboxStates
}: Props) {
  return (
    <Flex
      gap='4'
      direction={{ initial: 'column', sm: 'row' }}
    >
      {[...labelToDifficulty.keys()].map((label: string) => (
        <Text
          as='label'
          size='2'
          key={label}
          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
        >
          <Checkbox
            checked={checkboxStates[label]}
            onCheckedChange={checked =>
              onCheckedChange(label, checked as boolean)
            }
          />
          {label}
        </Text>
      ))}
    </Flex>
  );
}
